import { BagelChatMessage } from '../../types';

export interface BagelChatExport {
  exportedAt: string;
  pageContext?: string;
  messages: BagelChatMessage[];
}

function exportFilename(exportedAt: Date): string {
  const stamp = exportedAt.toISOString().replace(/[:.]/g, '-');
  return `bagel-chat-${stamp}.json`;
}

export function downloadBagelChatConversation(
  messages: BagelChatMessage[],
  pageContext?: string,
): void {
  if (messages.length === 0) return;

  const exportedAt = new Date();
  const payload: BagelChatExport = {
    exportedAt: exportedAt.toISOString(),
    pageContext,
    messages,
  };

  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = exportFilename(exportedAt);
  link.click();
  URL.revokeObjectURL(url);
}
